module.exports = __webpack_public_path__ + "img/dxsolution.dfe0dc7b.jpg";